import { render, staticRenderFns } from "./DetailPreview.vue?vue&type=template&id=7ce39b78&lang=pug&"
import script from "./DetailPreview.vue?vue&type=script&lang=js&"
export * from "./DetailPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports